'use strict';

angular.module('utils').factory('OCFormUtil', function() {
  return {
    /**
     * Runs a form saving, driving the `isSubmitted` / `isSaving` flags its template binds to.
     */
    submit: async ($scope, fn) => {
      $scope.$applyAsync(() => {
        $scope.isSubmitted = true;
        $scope.isSaving = true;
      });

      try {
        await fn();
      } catch (_error) {
        // httpResponseInterceptor has already growled the API's message (app.js), so there is
        // nothing left to tell the user.
      } finally {
        $scope.$applyAsync(() => {
          $scope.isSaving = false;
        });
      }
    },
  };
});
